<!--
    描述：新增角色
    日期：2021/04/29
    作者：zwh
-->
<template>
    <div>
        <el-form :model="objectForm" :rules="formRules" ref="objectForm" label-width="100px">
            <el-row v-if="objectForm.parentId != 0">
                <el-col :span="24">
                    <el-form-item label="上级角色" prop="" :show-message="false">
                        <el-input v-model="objectForm.parentName" autocomplete="off" disabled :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="角色名称" prop="roleName" :show-message="false">
                        <el-input v-model="objectForm.roleName" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="主体类型">
                        <el-select v-model="objectForm.limitId"
                                   placeholder="请选择">
                            <el-option v-for="item in limits"
                                       :key="item.id"
                                       :label="item.sname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="备注信息" prop="remark" :show-message="false">
                        <el-input type="textarea" v-model="objectForm.remark" autocomplete="off" :disabled="isDisabled" :show-message="false"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import {getLimits} from 'api/unitMaintain/unit'
import {saveOrUpdatePreinstall, getInfoById} from 'api/system/sysGroupInnerRole.js'
export default {
    name : '',
    props : {
        mode: {
            type: String,
            default: 'add'
        },
        transObj: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },

    data() {
        return {
            //角色类型
            roleTypeSelectList : [],
            limits : [],
            btnLoading: false,
            objectForm: {
                id : '',
                parentId : '',  //父角色id
                parentName : '',//父角色名称
                roleName: '',   //角色名称
                roleType : '1007001',  //角色类型 1007001：预设角色
                limitId :'',
                remark : '',
            },
            formRules: {
                roleName: [{required: true, message: '请输入...', trigger: 'blur'}],
                roleType: [{required: true, message: '请选择...', trigger: 'change'}],
                sortNum: [{required: true, message: '请输入...', trigger: 'blur'}],
            },
        }
    },
    computed: {
        // 是否可编辑
        isDisabled() {
            return this.mode === 'view' ? true : false
        }
    },
    created() {
        //赋值
        this.objectForm.id = this.transObj.id
        this.objectForm.parentId = this.transObj.parentId
        this.objectForm.parentName = this.transObj.parentName
        //编辑/修改/查看等
        if(this.objectForm.id != '') this.getObjectById()
        this.getLimits();
    },
    methods: {
        //根据id，获取角色信息
        getObjectById(){
            let that = this
            let param = { id : this.objectForm.id + '' }
            getInfoById(param).then(res => {
                if(res.operationCode==1){
                    res.data != null && res.data != '' ? this.objectForm = res.data : ''
                }
            });
        },
        //点击确定按钮事件
        doSave() {
            let that = this
            this.$refs['objectForm'].validate((valid) => {
                if (valid) {
                    let param = this.objectForm
                    saveOrUpdatePreinstall(param).then(res => {
                        if(res.operationCode==1){
                            if(res.msg=='faild') {
                                that.$message({message: res.data,type: 'error'});
                                return
                            }
                            that.$message({message: '保存成功',type: 'success'});
                            //刷新
                            that.$emit('handle-success')
                        }
                    });

                } else {
                    return false;
                }
            });
        },

        getLimits() {
            getLimits().then((res) => {
                this.limits = res.data
            })
        }
    }
}
</script>
<style lang="less">

</style>